export default "/images/vendor/flag-icons/flags/1x1/az.svg?28042690b69f4c26b9fb5d018cf288c4";